import { render, staticRenderFns } from "./HomeRewards.vue?vue&type=template&id=3a1af5db"
import script from "./HomeRewards.vue?vue&type=script&lang=js"
export * from "./HomeRewards.vue?vue&type=script&lang=js"
import style0 from "./HomeRewards.vue?vue&type=style&index=0&id=3a1af5db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports